import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { MathTopicEvents, MathTopicParamObject } from './mathTopicEvents.types'

class mathTopicAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.MATH_TOPICS)
  }

  public clickMainMathTopic(eventParams: MathTopicParamObject): void {
    this.logEvent({ event: MathTopicEvents.CLICKED_MAIN_MATH_TOPIC, ...eventParams })
  }

  public clickTopicProduct(eventParams: MathTopicParamObject): void {
    this.logEvent({ event: MathTopicEvents.CLICKED_TOPIC_PRODUCT, ...eventParams })
  }
}

export default new mathTopicAnalytics()
